import { Fragment, useEffect, useState } from "react";
import { Button, Card, Col, Modal, Row, Spinner, Table, Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import SearchableSelect from "../common/SearchableSelect";
import "./ModalCargasStatus.scss";
import {
	getAllData,
	getStatusCarga,
	verificaTipoUsuario,
	getDateInit,
	getStatusPedidos,
} from "../../services/Servicos";
import { getColorOfFilial, getErrorMessage, getFilialName } from "../../services/helpers";
import ModalErrorPretty from "./ModalErrorPretty";
import { getFCP } from "web-vitals";
import UserAvatar from "../common/UserAvatar";

export default function ModalCargasStatus({ show, setShow, statusFilter, statusName, dataParam, cargasDefault}) {
	const [cargas, setCargas] = useState([]);
	const [cargasOriginais, setCargasOriginais] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState({ show: false });
	const [modalPedidos, setModalPedidos] = useState({ show: false, cargaId: null, cargaNome: "" });
	const [filtros, setFiltros] = useState({
		filial: "",
		motorista: ""
	});
	const user = useSelector((state) => state.userSlice);
	const caminhoesFrete = user.freteiroList.data || [];
    const funcionarios = user.funcionariosList.data || [];
	const caminhoneiros = [...funcionarios.filter((f) => f.tipo === "Caminhoneiro"), ...caminhoesFrete.map((c) => ({ name: c.motorista_nome, cpf: c.motorista_cpf, foto_perfil: c.foto_perfil }))];

	const handlerClose = () => {
		setShow(last => ({ ...last, show: false, statusFilter: "", statusName: ""}));
		setCargas([]);
		setCargasOriginais([]);
		setFiltros({ filial: "", motorista: "" });
	};

	const openModalPedidos = (cargaId, cargaNome) => {
		setModalPedidos({ show: true, cargaId, cargaNome });
	};

	const closeModalPedidos = () => {
		setModalPedidos({ show: false, cargaId: null, cargaNome: "" });
	};

	const aplicarFiltros = () => {
		let cargasFiltradas = [...cargasOriginais];

		// Filtro por filial
		if (filtros.filial && filtros.filial !== "") {
			cargasFiltradas = cargasFiltradas.filter(carga => {
				const carregaFilial = carga.id_filial?.toString();
				return carregaFilial === filtros.filial;
			});
		}

		// Filtro por motorista
		if (filtros.motorista && filtros.motorista !== "") {
			cargasFiltradas = cargasFiltradas.filter(carga => 
				carga.caminhoneiro === filtros.motorista
			);
		}

		setCargas(cargasFiltradas);
	};

	const limparFiltros = () => {
		setFiltros({ filial: "", motorista: "" });
		setCargas(cargasOriginais);
	};

	const handleFiltroChange = (tipo, valor) => {
		setFiltros(prev => ({ ...prev, [tipo]: valor }));
	};

	// Aplicar filtros quando mudarem
	useEffect(() => {
		if (cargasOriginais.length > 0) {
			aplicarFiltros();
		}
	}, [filtros, cargasOriginais]);

	// Obter opções únicas para os filtros
	const obterFiliaisUnicas = () => {
		const filiais = cargasOriginais
			.map(carga => carga.id_filial)
			.filter((filial, index, arr) => arr.indexOf(filial) === index && filial != null)
			.sort();
		return filiais;
	};

	const obterMotoristasUnicos = () => {
		const motoristas = cargasOriginais
			.map(carga => carga.caminhoneiro)
			.filter((motorista, index, arr) => arr.indexOf(motorista) === index && motorista != null)
			.sort();
		return motoristas;
	};

	// Obter estatísticas de cargas por filial
	const obterEstatisticasPorFilial = () => {
		const estatisticas = {};
		const totalCargas = cargas.length;
		
		cargas.forEach(carga => {
			const filialId = carga.id_filial;
			if (filialId != null) {
				if (!estatisticas[filialId]) {
					estatisticas[filialId] = {
						id: filialId,
						nome: getFilialName(user.filiaisList.data, filialId),
						count: 0
					};
				}
				estatisticas[filialId].count++;
			}
		});

		// Adicionar percentual e ordenar por quantidade (decrescente)
		return Object.values(estatisticas)
			.map(filial => ({
				...filial,
				percentual: totalCargas > 0 ? ((filial.count / totalCargas) * 100).toFixed(1) : 0
			}))
			.sort((a, b) => b.count - a.count);
	};

	const calcularDiasLogistica = (dataEmissao, ultimaDataAtt) => {
		const dataEmissaoDate = new Date(dataEmissao);
		let dataAtual = new Date();
		if(statusFilter.split(",").find(i => Number(i) >= 13)) {
			dataAtual = new Date(ultimaDataAtt);
		}
		const diferencaMs = dataAtual - dataEmissaoDate;
		return Math.floor(diferencaMs / (1000 * 60 * 60 * 24));
	};

	const buscarCargas = async () => {
		if (!statusFilter) return;
		const finalDaFuncao = (cargasS) => {
			
			const statusArray = statusFilter.split(",").map((s) => parseInt(s.trim()));
		
			let cargasFiltradas = cargasS
				.filter((carga) => statusArray.includes(carga.status))
				.map((carga) => ({
					...carga,
					dias_logistica: calcularDiasLogistica(carga.emissao, carga.updatedAt),
				}));
				if(statusName == 'Finalizado pelo Suporte'){
					cargasFiltradas = cargasFiltradas.filter(carga => carga.is_finalizado_suporte);
				}
			setCargasOriginais(cargasFiltradas);
			setCargas(cargasFiltradas);
			setLoading(false);
		}

		setLoading(true);
		let cargasS = cargasDefault
		console.log(cargasDefault)
		if(!cargasDefault.length){
			try {
				// Definir datas usando dataParam ou datas padrão
				let datas = getDateInit(new Date());
				let data_inicial = datas.data_inicial;
				let data_final = datas.data_final;
	
				if (dataParam && dataParam.data_final && dataParam.data_inicial) {
					data_inicial = dataParam.data_inicial;
					data_final = dataParam.data_final;
				}
	
				let id_filial = user.id_filial;
				if (user.id_filial == 2) {
					id_filial = "";
				}
	
				const response = await getAllData(
					verificaTipoUsuario(user) + "cargas/separador/empresa",
					{
						data_inicial,  
						data_final,
						id_filial,
					}
				);
				cargasS = response.data
				finalDaFuncao(cargasS)
				setShow(last => ({...last, cargasDefault: cargasS}))
				
			} catch (error) {
				setError({ show: true, message: getErrorMessage(error) });
			} 
		}else{
			setTimeout(() => {
				finalDaFuncao(cargasS)
			}, 500)
		}
	};

	useEffect(() => {
		if (show && statusFilter) {
			buscarCargas();
		}
	}, [show, statusFilter, dataParam]);

	const formatarData = (data) => {
		return new Date(data).toLocaleDateString("pt-BR", {
			day: "2-digit",
			month: "2-digit",
			year: "numeric",
			// hour: "2-digit",
			// minute: "2-digit",
		});
	};

	return (
		<Fragment>
			<Modal
				show={show}
				onHide={handlerClose}
				backdrop="static"
				keyboard={false}
				centered
				size="xl"
			>
				<Modal.Header closeButton>
					<Modal.Title>
						<i className="bi bi-truck"></i> Cargas - {statusName}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
					<div className="mb-3 d-flex justify-content-between align-items-center">
								<small className="text-muted">
									Total de cargas: <strong>{cargas.length}</strong>
									{cargasOriginais.length !== cargas.length && (
										<span className="text-info ms-2">
											(filtradas de {cargasOriginais.length})
										</span>
									)}
								</small>
								
								{/* Seção de Filtros */}
								<div className="d-flex gap-2 align-items-center">
									<SearchableSelect
										placeholder="Todas as Filiais"
										value={filtros.filial}
										options={obterFiliaisUnicas().map(filial => ({
											value: filial?.toString(), // Garantir que seja string
											label: getFilialName(user.filiaisList.data, filial)
										}))}
										onChange={(e) => handleFiltroChange("filial", e.target.value)}
										name="filial"
										className="searchable-select-sm"
									/>
									
									<SearchableSelect
										placeholder="Todos os Motoristas"
										value={filtros.motorista}
										options={obterMotoristasUnicos().map(cpf => {
											const motorista = caminhoneiros.find(c => c.cpf === cpf);
											return {
												value: cpf,
												label: motorista?.name || cpf
											};
										})}
										onChange={(e) => handleFiltroChange("motorista", e.target.value)}
										name="motorista"
										className="searchable-select-sm"
									/>
								</div>
							</div>

							{/* Indicador de Cargas por Filial */}
							{cargas.length > 0 && (
								<div className="mb-3">
									<h6 className="text-muted mb-2">
										<i className="bi bi-pie-chart me-1"></i>
										Distribuição por Filial
									</h6>
									<div className="d-flex flex-wrap gap-2">
										{obterEstatisticasPorFilial().map(filial => (
											<div
												key={filial.id}
												className="filial-indicator d-flex align-items-center justify-content-between"
												style={{ 
													backgroundColor: "#f8f9fa",
													color: "#495057",
													padding: "0.5rem 0.75rem",
													borderRadius: "0.375rem",
													border: `2px solid ${getColorOfFilial(filial.id).bgColor}`,
													fontSize: "0.8rem",
													fontWeight: "500",
													minWidth: "140px",
													boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
												}}
											>
												<div className="d-flex align-items-center">
													<i 
														className="bi bi-house-fill me-2" 
														style={{ 
															fontSize: "0.9rem",
															fill: getColorOfFilial(filial.id).color
														}}
													></i>
													<span>{filial.nome}</span>
												</div>
												<div className="ms-2 text-end">
													<strong style={{ fontSize: "1rem" }}>{filial.count}</strong>
													<small className="d-block text-muted" style={{ fontSize: "0.65rem" }}>
														{filial.percentual}%
													</small>
												</div>
											</div>
										))}
									</div>
								</div>
							)}
					{loading ? (
						<div className="text-center p-4">
							<Spinner animation="border" variant="primary" />
							<p className="mt-2">Carregando cargas...</p>
						</div>
					) : cargas.length === 0 ? (
						<div className="text-center p-4">
							<i className="bi bi-inbox" style={{ fontSize: "3rem", color: "#ccc" }}></i>
							<p className="mt-2 text-muted">Nenhuma carga encontrada para este status</p>
						</div>
					) : (
						<Fragment>
							
							<Table responsive striped hover size="sm">
								<thead className="table-dark">
									<tr>
										<th>Nº Carga</th>
										<th>Status</th>
										<th>Data Criação</th>
										<th>Filial</th>
										<th>Região</th>
										<th>Usuário Criador</th>
										<th>Motorista</th>
										<th>Nº dos Pedidos</th>
										<th>Dias de Logística</th>
									</tr>
								</thead>
								<tbody>
									{cargas.map((carga, index) => (
										<tr key={index}>
											<td>
												<strong>{carga.nome || carga.id}</strong>
											</td>
											<td>
												<div className='d-flex align-items-center'>
													{carga.is_finalizado_suporte ? <i className="bi bi-shield-fill-check text-success me-1" title="Finalizado pelo Suporte"></i> : null}
													<span
														className={`badge ${
															carga.status <= 2
																? "bg-warning"
																: carga.status <= 4
																? "bg-info"
																: carga.status <= 10
																? "bg-primary"
																: carga.status <= 12
																? "bg-secondary"
																: carga.status === 13
																? "bg-warning"
																: carga.status === 14
																? "bg-success"
																: "bg-dark"
														}`}
													>
														{getStatusCarga(carga.status)}
													</span>
												</div>
											</td>
											<td style={{whiteSpace: "nowrap"}}>{formatarData(carga.emissao)}</td>
											<td>{carga.regiao_entrega}</td>
											<td>
												<div
													style={{
														color: getColorOfFilial(carga.id_filial).color,
														backgroundColor: getColorOfFilial(carga.id_filial)
														.bgColor,
														padding: "4px 6px",
														borderRadius: "4px",
														textAlign: "center",
														boxShadow: "0 0 5px #0A061E80",
														border: "1px solid #E2E3DF80",
														width: "max-content",
													}}
												>
												{getFilialName(user.filiaisList.data, carga.id_filial)}
												</div>
											</td>
														
											<td>{carga.responsavel || "N/A"}</td>
											<td><UserAvatar size="small" user={caminhoneiros.find(c => c.cpf === carga.caminhoneiro)}/></td>
											<td>
                                                <div className="d-flex align-items-center">
                                                    <i
                                                        className="bi bi-list-ul text-primary me-2"
                                                        style={{ cursor: "pointer", fontSize: "1.1rem" }}
                                                        title="Ver pedidos desta carga"
                                                        onClick={() => openModalPedidos(carga.id, carga.nome || carga.id)}
                                                    ></i>
                                                    <small>{carga.qtde_pedidos}</small>
                                                </div>
											</td>
											<td>
												<span
													className={`badge ${
														carga.dias_logistica <= 3
															? "bg-success"
															: carga.dias_logistica <= 7
															? "bg-warning"
															: "bg-danger"
													}`}
												>
													{carga.dias_logistica} dias
												</span>
											</td>
										</tr>
									))}
								</tbody>
							</Table>
						</Fragment>
					)}
				</Modal.Body>
			</Modal>

			{error.show && (
				<ModalErrorPretty
					show={error.show}
					setShow={setError}
					message={error.message}
				/>
			)}

			<ModalListarPedidosCarga
				show={modalPedidos.show}
				onClose={closeModalPedidos}
				cargaId={modalPedidos.cargaId}
				cargaNome={modalPedidos.cargaNome}
			/>
		</Fragment>
	);
}

// Componente para listar os pedidos de uma carga específica
function ModalListarPedidosCarga({ show, onClose, cargaId, cargaNome }) {
	const [pedidos, setPedidos] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState({ show: false });
	const user = useSelector((state) => state.userSlice);

	const buscarPedidosDaCarga = async () => {
		if (!cargaId) return;

		setLoading(true);
		try {
			// Assumindo que existe um endpoint para buscar pedidos por carga
			const response = await getAllData(
				verificaTipoUsuario(user) + `cargas/pedidos/empresa?cargas_id=${cargaId}`
			);
			setPedidos(response.data || []);
		} catch (error) {
			setError({ show: true, message: getErrorMessage(error) });
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (show && cargaId) {
			buscarPedidosDaCarga();
		}
	}, [show, cargaId]);

	const formatarData = (data) => {
		return new Date(data).toLocaleDateString("pt-BR", {
			day: "2-digit",
			month: "2-digit",
			year: "numeric",
		});
	};

	return (
		<Fragment>
			<Modal
				show={show}
				onHide={onClose}
				backdrop="static"
				keyboard={false}
				centered
				size="lg"
			>
				<Modal.Header closeButton>
					<Modal.Title>
						<i className="bi bi-list-ul"></i> Pedidos da Carga {cargaNome}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
					{loading ? (
						<div className="text-center p-4">
							<Spinner animation="border" variant="primary" />
							<p className="mt-2">Carregando pedidos...</p>
						</div>
					) : pedidos.length === 0 ? (
						<div className="text-center p-4">
							<i className="bi bi-inbox" style={{ fontSize: "3rem", color: "#ccc" }}></i>
							<p className="mt-2 text-muted">Nenhum pedido encontrado para esta carga</p>
						</div>
					) : (
						<Fragment>
							<div className="mb-3">
								<small className="text-muted">
									Total de pedidos: <strong>{pedidos.length}</strong>
								</small>
							</div>
							<Table responsive striped hover size="sm">
								<thead className="table-dark">
									<tr>
										<th>Nº Pedido</th>
										<th>Cliente</th>
										<th>Data Emissão</th>
										<th>Valor</th>
										<th>Fotos</th>
										<th>Assinou danfe</th>
									</tr>
								</thead>
								<tbody>
									{pedidos.map((pedido, index) => (
										<tr key={index}>
											<td>
												<strong>{pedido.numero_pedido || pedido.id}</strong>
											</td>
											<td>{pedido.nome_razao || "N/A"}</td>
											<td>{formatarData(pedido.emissao)}</td>
											<td style={{ whiteSpace: "nowrap" }}>
												{pedido.valor_total 
													? `R$ ${Number(pedido.valor_total).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`
													: "N/A"
												}
											</td>
											<td>
												{pedido.foto_pedido_entregue ?? "N/A"}
											</td>
											<td>
												{pedido.danfe ? <i className="bi bi-check-circle-fill" style={{ color: "green" }}></i> : <i className="bi bi-x-circle-fill" style={{ color: "red" }}></i>}
											</td>
										</tr>
									))}
								</tbody>
							</Table>
						</Fragment>
					)}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={onClose}>
						<i className="bi bi-x-circle"></i> Fechar
					</Button>
				</Modal.Footer>
			</Modal>

			{error.show && (
				<ModalErrorPretty
					show={error.show}
					setShow={setError}
					message={error.message}
				/>
			)}
		</Fragment>
	);
}
